import Axios from "@/plugins/Axios";
import AtendimentoAuxiliar from "@/Models/AtendimentoAuxiliar";

/**
 * Relatórios Diários do Diário de Auxiliares, de 2026 em diante (#7286).
 * Namespace de permissão próprio no back: atendimentosAuxiliares.*
 */
export class AtendimentosAuxiliaresService {
  async listar(gestaoId, pageNumber = 1, porPagina = 10) {
    const response = await Axios().get(
      `atendimentos-auxiliares/${gestaoId}?page=${pageNumber}&por_pagina=${porPagina}`
    );
    return {
      ...response.data,
      data: (response.data.data || []).map((item) => new AtendimentoAuxiliar(item)),
    };
  }

  async visualizar(gestaoId, atendimentoId) {
    const response = await Axios().get(`atendimentos-auxiliares/${gestaoId}/${atendimentoId}`);
    return new AtendimentoAuxiliar(response.data);
  }

  async criar(gestaoId, atendimento) {
    const response = await Axios().post(`atendimentos-auxiliares/${gestaoId}`, atendimento);
    return new AtendimentoAuxiliar(response.data);
  }

  async atualizar(gestaoId, atendimentoId, atendimento) {
    const response = await Axios().put(
      `atendimentos-auxiliares/${gestaoId}/${atendimentoId}`,
      atendimento
    );
    return new AtendimentoAuxiliar(response.data);
  }

  async alterarSituacao(gestaoId, atendimentoId, situacao, motivo = null) {
    const response = await Axios().put(
      `atendimentos-auxiliares/${gestaoId}/${atendimentoId}/situacao`,
      { situacao, motivo }
    );
    return new AtendimentoAuxiliar(response.data);
  }

  async deletar(gestaoId, atendimentoId) {
    const response = await Axios().delete(`atendimentos-auxiliares/${gestaoId}/${atendimentoId}`);
    return response.data;
  }

  /** Só os horários do turno da turma do vínculo (Cenário 4). */
  async horarios(gestaoId) {
    const response = await Axios().get(`atendimentos-auxiliares/${gestaoId}/horarios`);
    return response.data;
  }

  /** Documento Atendimentos do mês (Cenário 7). */
  async documentoDeAtendimentos(gestaoId, mes) {
    return Axios()
      .get(`atendimentos-auxiliares/${gestaoId}/documentos/atendimentos/${mes}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        window.open(window.URL.createObjectURL(blob));
      });
  }

  /** Histórico de Atendimentos (Cenário 6). */
  async historico(gestaoId) {
    const response = await Axios().get(`atendimentos-auxiliares/${gestaoId}/documentos/historico`);
    return response.data;
  }
}

export default new AtendimentosAuxiliaresService();
